import React from 'react';
import AppHeadsup from '../app-headsup/app-headsup';
import { AppChatMessages } from '../app-chat-messages/app-chat-messages';
import AppChatFileUploads from '../app-chat-file-uploads/app-chat-file-uploads';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './app-chat.css';
import appState from '../../state/AppStateContainer';
import moment from 'moment';
import { ServiceChat } from '../../services/service-chat';
import PageInternalChatMember from '../page-internal-chat/page-internal-chat-member';
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import ChatInput from '../app-chat-write-message/ChatInput';
import { FileScope } from '../../util/appEnum';
import { resizeScroller } from '../app-chat/app-chat';

moment.locale('sv');

export class AppInternalMessage extends React.Component {
  state = {
    clients: [],
    currentSupplier: {},
    currentClient: {},
    totalFilesClient: [],
    totalFilesUser: [],
    messages: []
  };
  elColumnOverflow;
  elMessages;
  elColumnUploads;
  elAppChatWriteMessage;
  elAppChatFileUploads;
  elAppHeadsup;

  element;

  messages = this.props.messages;
  currentSupplier = this.props.currentSupplier;
  currentClient = this.props.currentClient;
  clients = this.props.clients;
  totalFilesClient = this.props.totalFilesClient;
  totalFilesUser = this.props.totalFilesUser;
  baseURL = this.props.baseURL;
  role = this.props.role;
  newMessage = [];
  chatOnly = this.props.chatOnly;
  notReadMessageCounter;

  sendMessage(data, animateScroll) {
    var func = () => {
      this.props.currentClient.hasConversation = true;
      this.setState({
        clients: [...this.props.clients]
      });

      if (data.type == 'client') {
        this.setState({
          totalFilesClient: [...this.props.totalFilesClient, ...data.files]
        });
      } else {
        this.setState({
          totalFilesUser: [...this.props.totalFilesUser, ...data.files]
        });
      }
    };

    if (animateScroll) {
      this.scrollTop(func);
    } else {
      func();
    }
  }

  scrollTop(func) {
    var scrollYpos = this.elMessages.scrollTop;
    var duration = 1000;
    var delay = 0;
    if (scrollYpos <= 0) {
      duration = 0;
      delay = 0;
    } else if (scrollYpos < 200) {
      duration = 300;
    }

    var obj = {
      targets: this.elMessages,
      scrollTop: 0,
      duration: duration,
      delay: delay,
      easing: 'easeInOutCubic',
      complete: func
    };
    if (!func || func instanceof Event) {
      delete obj.complete;
    }
  }

  async elWriteMessageSubmit(data) {
    if (data.message == '' && _.isEmpty(data.files)) {
      return;
    }
    var today = new Date();
    const messageObj = {};
    messageObj.message = data.message || '';
    messageObj.name = appState.state.token.name;
    messageObj.email = appState.state.token.email;
    messageObj.phone = appState.state.token.phone;
    messageObj.type = 'user';
    messageObj.date = moment();
    messageObj.timestamp =
      today.getFullYear() + '-' + today.getMonth() + '-' + today.getDay();
    messageObj.files = data.files.map(x => ({
      mimeType: x.mimeType,
      date: moment(),
      file: x.name
    }));
    this.sendMessage(messageObj);
    await ServiceChat.sendMessage(
      this.props.currentClient._id,
      data.message,
      data.files
    );
  }

  editMemberBtnCallback(isOwnEdit) {
    if (this.props.editMemberBtnCallback) {
      let obj = this.props.currentClient;
      obj.isOwnEdit = isOwnEdit;
      this.props.editMemberBtnCallback(obj);
    }
  }

  render() {
    const isGhost = appState.isGhostUser();
    return (
      <div className="app-chat">
        <div ref={el => (this.elAppHeadsup = el)}>
          <AppHeadsup
            onClick={this.scrollTop.bind(this)}
            count={this.notReadMessageCounter}
          />
        </div>
        <BtGrid className="chat-msg-cn-wrapper info--style" id="chat-msg-cn-wrapper">
          <BtRow className="chat-message-window">
              <div
                className="custom-scrollbar chat-message-scroller style--2"
                ref={el => (this.elMessages = el)}
              >
                <AppChatMessages
                  currentClient={this.props.currentClient}
                  chatOnly={this.props.chatOnly}
                  scope={FileScope.InternalConversation}
                  scopeOptions={{
                    toUserId: this.props.currentClient._id
                  }}
                  messages={
                    _.isEmpty(this.state.messages)
                      ? this.props.messages
                      : this.state.messages
                  }
                  className="messages"
                />
              </div>
            <BtColumn
              className="bt-contract column-uploads uploads-gallery-wrapper"
              id="uploads-gallery-wrapper"
              ref={el => (this.elColumnUploads = el)}
            >
              <AppChatFileUploads
                nameUser={`${this.props.adminUser.name}`}
                nameClient={this.props.currentClient.name}
                scope={FileScope.InternalConversation}
                scopeOptions={{
                  toUserId: this.props.currentClient._id
                }}
                filesClient={
                  _.isEmpty(this.state.totalFilesClient)
                    ? this.props.totalFilesClient
                    : this.state.totalFilesClient
                }
                filesUser={
                  _.isEmpty(this.state.totalFilesUser)
                    ? this.props.totalFilesUser
                    : this.state.totalFilesUser
                }
                ref={el => (this.elAppChatFileUploads = el)}
              />
            </BtColumn>
          </BtRow>
          {!isGhost && appState.state.token.id !== this.props.currentMember._id && this.props.currentMember?._id && (
            <BtRow className="bt-contract app-chat-footer">
              <BtColumn>
                <ChatInput onSubmit={this.elWriteMessageSubmit.bind(this)} resizeScroller={resizeScroller}/>
              </BtColumn>
            </BtRow>
          )}
        </BtGrid>
      </div>
    );
  }
}
